import * as React from 'react'
import { Text } from 'web-makeup/dist/design-system/styles/typography'

import { Button, Buttons, Container } from './PopUp.style'

export interface PopUpProps {
  onNo: () => void
  onYes: () => void
  style?: React.CSSProperties
  text?: string
}

const PopUp: React.FC<PopUpProps> = ({ onNo, onYes, style, text }) => {
  return (
    <Container style={style}>
      <Text as="p" fontSize="h5" color="white" lineHeight="big" textAlign="center">
        {text ? text : `Are you sure you want to remove this template?`}
      </Text>
      <Buttons>
        <Button onClick={onNo}>No</Button>
        <Button onClick={onYes}>Yes</Button>
      </Buttons>
    </Container>
  )
}

export default PopUp



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/PopUp/PopUp.tsx